import { ISelectRange, RangeMode } from '../types';
import inRange from 'lodash/inRange';

const INVALID_IDX = -1;

const defaultSelectedRange: ISelectRange = Object.freeze({
  rowIdx: INVALID_IDX,
  columnIdx: INVALID_IDX,
  endRowIdx: INVALID_IDX,
  endColumnIdx: INVALID_IDX,
  mode: RangeMode.SELECT,
});

function isRangeSelected(range: ISelectRange) {
  return range !== defaultSelectedRange;
}

function isCellInRange(columnIdx: number, rowIdx: number, range: ISelectRange) {
  const beginColumnIdx = Math.min(range.columnIdx, range.endColumnIdx);
  const endColumnIdx = Math.max(range.columnIdx, range.endColumnIdx);
  const beginRowIdx = Math.min(range.rowIdx, range.endRowIdx);
  const endRowIdx = Math.max(range.rowIdx, range.endRowIdx);
  if (
    inRange(columnIdx, beginColumnIdx, endColumnIdx + 1) &&
    inRange(rowIdx, beginRowIdx, endRowIdx + 1)
  ) {
    return true;
  }
  return false;
}

export { defaultSelectedRange, isRangeSelected, isCellInRange };
